import { z } from 'zod';

/**
 * GET /api/organization/tree
 * Бэкенд: id, label, depth, children (id дочерних), department — camelCase.
 * icon опционален; если нет — подставляется на фронте.
 */
export const orgTreeNodeSchema = z.object({
  id: z.string(),
  label: z.string(),
  depth: z.number(),
  icon: z.string().optional(),
  children: z.array(z.string()),
  department: z.string().optional(),
});

export type OrgTreeNode = z.infer<typeof orgTreeNodeSchema>;

/** GET /v1/org-units/tree — узел дерева оргструктуры (lazy, depth=1). */
export const orgUnitTreeItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  parent_id: z.string().nullable(),
  has_children: z.boolean(),
  breadcrumb_path: z.string().nullable().optional(),
});

export type OrgUnitTreeItem = z.infer<typeof orgUnitTreeItemSchema>;

export const orgUnitsTreeResponseSchema = z.object({
  items: z.array(orgUnitTreeItemSchema),
});

export type OrgUnitsTreeResponse = z.infer<typeof orgUnitsTreeResponseSchema>;
